import React, { useState } from 'react';
import { extractScopeFromContract, selectLoader } from 'utils/Helpers';
import uploadIcon2 from 'assets/img/upload-icon2.svg';

const UploadContractOnly = ({ onUploadSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = null;

    setSelectedFile(file);
    setLoading(true);

    const res = await extractScopeFromContract(file);

    if (!res) {
      setLoading(false);
      return;
    }

    let formattedScope = '';
    if (res.scope) {
      formattedScope = res.scope
        .split('\n')
        .map((line) => `<p>${line}</p>`)
        .join('');
    }

    onUploadSuccess(file, {
      scope: formattedScope,
      milestones: res.milestones || [],
      project: res.project || null
    });

    setLoading(false);
    setSelectedFile(null);
  };

  return (
    <div className="contract-upload-wrapper">
      <div className="contract-upload-card text-center">
        <div className="upload-icon-wrap mb-3">
          <img src={uploadIcon2} alt="upload" width={40} className="uploadIcon2" />
        </div>

        <h5>{selectedFile ? selectedFile.name : 'Upload Contract for AI Extraction'}</h5>

        {!loading && (
          <p className="text-muted">
            Upload your contract and we'll automatically extract the scope of work and milestones
          </p>
        )}

        {loading ? (
          <label className="btn btn-success fetching-contract-loader">
            {selectLoader(20)}
            Parsing with AI
            <input type="file" hidden accept=".pdf,.doc,.docx,.txt" disabled={true} />
          </label>
        ) : (
          <label className="btn btn-success">
            <img src={uploadIcon2} alt="upload" width={40} className="uploadIcon2-img" />
            Choose Contract File
            <input type="file" hidden accept=".pdf,.doc,.docx,.txt" onChange={handleUpload} />
          </label>
        )}
        <p className="file-name">Supports PDF, DOC, DOCX, and TXT files</p>
      </div>
    </div>
  );
};

export default UploadContractOnly;
